import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationCN from './locales/cn.json';

// The translations
const resources = {
  en: { translation: translationEN },
  cn: { translation: translationCN },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already protects from xss
    },
  });

export default i18n;
